import Vue from 'vue';
import Progress from './src/progress.vue'

Vue.use(Progress)

/* istanbul ignore next */
Progress.install = function (Vue) {
  Vue.component('k-progress', Progress);
};

export default Progress;



// WEBPACK FOOTER //
// ./src/components/progress/index.js